module.exports = __webpack_public_path__ + "media/images/riders/VICTOR_KORETZKY-f3d806c4743e382be4c98c24c58b4a30.png";